import './index.scss';

import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<App />);

// remove boot splash
const el = document.getElementById("boot-splash");
if (el) {
  el.classList.add("boot-splash--hide");
  setTimeout(() => el.remove(), 350);
}
reportWebVitals();
